import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useDestinations() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    // `axios`, `API`, the local `active` flag and `setItems` are all module-
    // level / stable / scoped to this effect — they are intentionally NOT
    // dependencies. We want this fetch to run exactly once on mount.
    let active = true;
    axios
      .get(`${API}/destinations`)
      .then((res) => {
        if (active) setItems(res.data.destinations || []);
      })
      .catch(() => {
        if (active) setItems([]);
      });
    return () => {
      active = false;
    };
  }, []);
  return items;
}
